<template>
  <div class="validation">
    <label class="block text-gray-700 text-smaller font-bold">
      Kortnummer
      <div class="border rounded py-053 pl-2" :class="cardInputClasses" ref="card"></div>
    </label>
    <div class="text-error" role="alert">{{ cardErrors }}</div>
  </div>
</template>
<script>
  import { includeScript } from '../utils/include-script'
  import Bugsnag from '@bugsnag/js'

  export default {
    name: 'StripeCard',
    props: {
      futureUsage: {
        type: Boolean,
        default: false
      },
      amount: {
        type: Number,
        default: undefined,
      },
      name: {
        type: String,
        default: undefined,
      },
      email: {
        type: String,
        default: undefined,
      },
    },
    mounted() {
      includeScript('js.stripe.com/v3/', this.configureStripe, 'stripe-src')
    },
    data() {
      return {
        cardElement: undefined,
        stripe: undefined,
        cardValidated: undefined,
        cardErrors: undefined,
        style: {
          base: {
            color: "#32325d",
            fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
            fontSmoothing: "antialiased",
            fontSize: "16px",
            "::placeholder": {
              color: "#aab7c4"
            }
          },
          invalid: {
            color: "#fa755a",
            iconColor: "#fa755a"
          }
        },
      }
    },
    computed: {
      cardInputClasses() {
        if (!this.cardValidated) return 'border-gray-400'

        return this.cardValidated == 'valid' ?
          'border-green-500' : 'border-red-600'
      },
    },
    methods: {
      configureStripe() {
        if (!this.stripe && !this.cardElement) {
          // eslint-disable-next-line no-undef
          this.stripe = Stripe(process.env.STRIPE_PUBLISHABLE_KEY)
          this.cardElement = this.stripe.elements().create('card', { hidePostalCode: true, style: this.style })
          this.cardElement.mount(this.$refs.card)
          this.cardElement.addEventListener('change', this.cardChangeListener)
        }
      },
      cardChangeListener(e) {
        if (e.error) {
          this.cardValidated = 'invalid'
          this.cardErrors = e.error.message
        } else if (e.complete) {
          this.cardValidated = 'valid'
          this.cardErrors = ''
        } else {
          this.cardValidated = undefined
        }
      },
      async confirmCard(clientSecret, stripeCustomer) {
        try {
          const futureUsageJson = this.futureUsage ? { setup_future_usage: 'off_session' } : {}
          const result = await this.stripe.confirmCardPayment(clientSecret,
            {
              payment_method: {
                card: this.cardElement,
                billing_details: {
                  name: this.name,
                  email: this.email,
                }
              },
              ...futureUsageJson
            })
          if (result.error) {
            console.warn({error: result.error})
            if (result.error.code && result.error.message) {
              Bugsnag.notify(new Error(result.error.message))
              this.$emit('confirmCardFailure', `${result.error.message}`)
            } else {
              Bugsnag.notify(new Error(result))
              this.$emit('confirmCardFailure',
                "Något gick fel när ditt kreditkort skulle användas. Vänligen försök igen eller kontakta givarservice på 070-648 47 89."
              )
            }
            return
          }
          if (result.paymentIntent.status === 'succeeded') {
            this.$emit('confirmCardSuccess', { stripeCustomer, paymentIntent: result.paymentIntent })
          } else {
            Bugsnag.notify(new Error("Oväntat Stripe fel, paymentIntent: " + result.paymentIntent.id + ", " + result.paymentIntent.status))
            this.$emit('confirmCardFailure',
              "Något gick fel när ditt kreditkort skulle användas. Vänligen försök igen eller kontakta givarservice på 070-648 47 89."
            )
          }
        } catch (e) {
          Bugsnag.notify(e)
          this.$emit('confirmCardFailure',
             "Något gick fel när ditt kreditkort skulle användas. Vänligen försök igen eller kontakta givarservice på 070-648 47 89."
          )
        }
      },
    }
  }
</script>
